import React, { useState, useEffect } from "react";
// import Back from '../../assets/Back.png';

import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    Container,
    IconButton
} from '@mui/material';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TaskIcon from "@mui/icons-material/TaskAlt";
import EventIcon from "@mui/icons-material/Event";
import GroupIcon from '@mui/icons-material/Group';
import ChecklistIcon from '@mui/icons-material/Checklist';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';


import { axiosInstance, localAxiosGet } from "../../../Axios/axios";
// import axios from "axios";

const EmployeeCards = ({ onCardSelect }) => {
    const [dashboardStats, setdashboardStats] = useState({});
    const userId = localStorage.getItem('userId');
    const accessToken = localStorage.getItem('accessToken');

    useEffect(() => {
        fetchDashBoardStats();
    }, []);

    const fetchDashBoardStats = async () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        try {
            const response = await axiosInstance(localAxiosGet(`/organization/getDashboardDetailsByEmployeeId?userId=${userId}&year=${year}&month=${month + 1}`, accessToken));
            console.log('respone data', response.data.message.dashboard);
            setdashboardStats(response.data.message.dashboard);
        } catch (error) {
            console.log('Error in fetching the dashboard statistics', error);
        }
    };

    const cardData = [
        {
            id: "My Projects",
            title: "Total Projects",
            count: dashboardStats.totalProjects,
            icon: <CalendarTodayIcon sx={{ fontSize: 36, color: "#4158D0" }} />,
            background: "linear-gradient(to right, #E0F7FA, #B2EBF2)",
            color: "#1A237E",
            onClickAction: () => onCardSelect("My Projects"),
        },
        {
            id: "My Tasks",
            title: "Active Tasks",
            count: dashboardStats.activeTasks,
            icon: <TaskIcon sx={{ fontSize: 36, color: "#0093E9" }} />,
            background: "linear-gradient(to right, #E1F5FE, #B3E5FC)",
            color: "#0D47A1",
            onClickAction: () => onCardSelect("My Tasks"),
        },
        {
            id: "My Attendance",
            title: "Monthly Attendance",
            count: dashboardStats.attendanceRate,
            icon: <EventIcon sx={{ fontSize: 36, color: "#8EC5FC" }} />,
            background: "linear-gradient(to right, #F3E5F5, #E1BEE7)",
            color: "#4A148C",
            onClickAction: () => onCardSelect("My Attendance"),
        },
        {
            id: "My Leaves",
            title: "Leave Balance",
            count: dashboardStats.leaveBalance,
            icon: <GroupIcon sx={{ fontSize: 36, color: "#FF3CAC" }} />,
            background: "linear-gradient(to right, #FFE0B2, #FFCC80)",
            color: "#E65100",
            onClickAction: () => onCardSelect("My Leaves"),
        },
    ];

    return (
        <Box sx={{ p: 2, bgcolor: "#f4f6f8", minHeight: "100vh" }}>
            <Box sx={{ mb: 2 }}>
                <Box>
                </Box>
                <Box>
                    <Typography variant="h4" fontWeight="bold" component="h3" gutterBottom>
                        Home
                    </Typography>
                </Box>
            </Box>
            <Grid container spacing={3} marginBottom={3}>
                {cardData.map((card, index) => (
                    <Grid item  xs={6} md={4} key={index}>
                        <Card
                            sx={{
                                borderRadius: 2,
                                boxShadow: 3,
                                background: card.background,
                                transition: "transform 0.3s ease",
                                cursor: "pointer",
                                "&:hover": {
                                    transform: "scale(1.05)",
                                },
                            }}
                            onClick={card.onClickAction}
                        >
                            <CardContent>
                                <Box gap={1} display="flex" flexDirection="column" alignItems="flex-start">
                                    <Box sx={{ mb: 1 }}>
                                        {card.icon}
                                    </Box>
                                    <Typography variant="h6" fontWeight="bold" color={card.color} gutterBottom>
                                        {card.title}
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                        }}
                                    >
                                        <Typography variant="h5" fontWeight={600} color="#3c3c3c">
                                            {card.count}
                                        </Typography>
                                        <IconButton
                                            sx={{
                                                padding: '6px',
                                                borderRadius: '50%',
                                                transition: 'transform 0.3s ease',
                                                '&:hover': {
                                                    transform: 'scale(1.3)',
                                                },
                                            }}
                                        >
                                            <EastOutlinedIcon
                                                fontSize="large"
                                                sx={{
                                                    color: '#333',
                                                }}
                                            />
                                        </IconButton>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
export default EmployeeCards;